module.exports = __webpack_public_path__ + "img/train_banner.da5597c1.png";